import React, {useEffect, useState} from 'react'
import Form from './Form'
import styled from '@emotion/styled'
import PrescriptionBox from '../header/PrescriptionBox'
import {getCompanyContact,addFeedback} from "../../network";
import LoadingComponent from '../shared/LoadingComponent';

const ContactWrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;

    @media (max-width:425px){
       
    }
`;

const PrescriptionHeader = styled.h1`
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-40);
    line-height: var(--space-48);
    color: var(--company-dark);
`;

const ContactContainer = styled.div`
    margin-top: 4rem;
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 90%;
    justify-content:space-between;
    align-items:center;
    @media only screen and (max-width: 768px) {
        height:100%;
        display:flex;
        flex-direction:column;
        padding-left: 2rem;
    }
    @media only screen and (max-width: 500px) {
        display:flex;
        flex-direction:column;
        padding-left: 0;
        width: 90vw;
    }
`;
const ContactTextContainer = styled.div`
    white-space:nowrap;
    @media only screen and (max-width: 768px) {
      
      
    }
    @media only screen and (max-width: 425px) {
        width:5rem;
        
    }
 
`;

const ContactTextHeader = styled.h1`
    position:relative;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-24);
    line-height: var(--space-24);
    color:var(--company-dark);

    @media (max-width: 500px){
        padding-left: 3rem;
    }
`;
const ContactNumberContainer = styled.div`
    position:relative;
    margin-top:1rem;
    display:grid;
    grid-gap: 1.5rem;
    grid-auto-flow:row;
    @media only screen and (max-width: 425px) {
       justify-content:center;
    }
`;
const FeedbackContainer = styled.div`
    margin-top:10rem;
    margin-bottom:8rem;
    display:flex;
    flex-direction:row-reverse;
    padding: var(--space-40) var(--space-64) var(--space-64);
    width:fit-content;
    justify-content:space-between;

    @media only screen and (max-width: 1100px) {
        padding-left: var(--space-6);
    }
    @media only screen and (max-width: 768px) {
        position: relative;
        margin-top: 2rem;
        margin-bottom: -2rem;
        right: 3rem;
    }
    @media only screen and (max-width: 500px) {
        right: 12rem;
    }
 
`;
const FeedbackImageContainer = styled.div`
    width:27.5rem;
    height:30rem;
    margin-right: 5rem;
    img{
        object-fit:contain;
        width:fit-content;
        height:fit-content;
    }
    @media only screen and (max-width: 1100px) {
        margin-right: 0;
    }
    @media only screen and (max-width: 768px) {
        display:none;
    }
`;
const FormContainer = styled.div`
    justify-self:flex-end;
    @media only screen and (max-width: 425px) {
        
        
    }
`;

const Divider = styled.div`
    width: 15.25rem;
    background-color:var(--color-gray-200);
    height: 0.1rem;
    opacity: 1;
`;

const Separator = styled.div`
    width: 35.25rem;
    background-color:var(--color-gray-200);
    height: 0.1rem;
    opacity: 1;
`;
const Spacing = styled.div`
    display:grid;
    grid-auto-flow:column;
    grid-gap:1rem;
    width:10rem;

    @media (max-width: 500px){
       > .map{
            display: none;
        }
       > .social{
            padding-left: 4rem;
        }
        >.contact{
            padding-left: 3rem;
        }
    }
`;
const Address = styled.div`
    display:grid;
    grid-auto-flow:row;
    grid-gap:1rem;

    @media (max-width: 500px){
        padding-left: 0.5rem;
        text-align: center;
        color: var(--company-dark);
        font-weight: 600;
    }
`;
const Gradient = styled.div`
    position: absolute;
    width: 100%;
    height: 13.25rem;
    left: 0rem;
    top: 40.6rem;
    z-index:-1;
    background: url(/img/bg.svg);

    @media only screen and (max-width: 425px) {
        display:none
    }
    
`;
const BigDivider = styled.div`
    position: absolute;
    width: 43.1785rem;
    height: 0rem;
  
    opacity: 0.25;
    color:var(--color-gray-400);
`;

const AlertContainer = styled.div`
    display: flex;
    position: absolute;
    top: 16rem;
    max-width: 10rem;
    height: 0rem;
    background-color: var(--color-green-500);
    border-radius: var(--space-8);
    align-items: center;
    justify-content: center;
    border: 1px solid var(--color-gray-400);
    color: var(--color-white);
    font-family: Inter, sans-serif;
    font-size: var(--font-16);
    font-weight: 600;
    padding: var(--space-18);

    
`;

function Contact() {
    const [numbers, setNumbers] = useState([]);
    const [address, setAddress] = useState(null);
    const [email, setEmail] = useState('');
    const [loading,setLoading] = useState(true);
    const [alert, setAlert] = useState(false);
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        handleResize();
    });
    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };

    useEffect(() => {
        // todo: pull from redux
        getCompanyContact().then(result => {
           
            setNumbers([...result.phone]);
            setAddress({
                line_1: result.address_line_1,
                line_2: result.address_line_2,
                parish: result.parish,
            });
            setEmail(result.email);
        })  .catch(error => {
            console.error(error);
       
        })
        .finally(() => setLoading(false));

        window.scrollTo(0, 0);
    }, [])

    const sendContact = (name,mail,message,type) =>{
        addFeedback(name,mail,message,type)
        .then(result => {
            result.send(name,mail,message,type);
        
        })
        .catch(error => console.error(error))
        .finally(() => {
            setAlert(true);
            setTimeout(() => {
                window.location.reload(false);
            }, 2000);
        });
    }

    // const sendFeedback = (name,mail,type) =>{
    //     addFeedback()
    //     .then(result => result.send(name,mail,type))
    //     .catch(error => console.error(error));
    // }

    return (
        <>
        {loading ?
            <LoadingComponent/>
        :    
    
        <ContactWrapper>
            <ContactContainer>
                {alert && <AlertContainer>Message Sent</AlertContainer>}
                <Form title="Get in Touch" contact={sendContact}sub="Have any queries? Get in touch, ask us your questions." btntext="Send" color="var(--company-dark)"
                shadow="var(--company-button-shadow)"/>
             <ContactTextContainer>
                <BigDivider/>
                
                <ContactNumberContainer>
                <ContactTextHeader>Contact Us</ContactTextHeader>
                    {/* {
                        numbers.map((number, index) => <Spacing key={index}><span>
                            <img src="/img/svg/phone.svg" alt="phone" />{number}
                        </span></Spacing>)
                    )} */}
                    <Spacing><img className="contact" src="/img/svg/phone.svg" alt="phone" /><span>
                            876-754-7688
                        </span></Spacing>
                        {/* <Spacing><img className="contact" src="/img/svg/phone.svg" alt="phone" /><span>
                            876-481-7535
                        </span></Spacing> */}
                        <Spacing ><img className="contact" src="/img/svg/whatsapp.svg" alt="whatsapp" /><span>
                        876-481-7535
                        </span></Spacing>
                   <Divider/>
                   <Spacing><img className="map" src="/img/svg/map.svg" alt="whatsapp" />
                    <Address>{
                        address && <>
                            {/* <p className="address" style={{width:"14rem"}}>{address.line_1}</p>
                            <p className="address">{address.line_2}</p> */}
                            <p className="address" style={{width:"14rem"}}> 28 Half Way Tree Road </p>
                            <p className="address"> Kingston 5</p>
                            {/* <p className="address">{address.parish}</p> */}
                        </>
                    }</Address></Spacing>
                    <Divider/>
                    <Spacing><img src="/img/svg/email.svg" alt="email" /><span>{email}</span></Spacing>
                    <Divider/>
                    <Spacing>
                        <img className="social" src="/img/svg/twitter.svg" alt="twitter" />
                        <img src="/img/svg/youtube.svg" alt="twitter" />
                        <img src="/img/svg/facebook.svg" alt="twitter" />
                    </Spacing>
                </ContactNumberContainer>
              </ContactTextContainer>
            </ContactContainer>
            <Gradient/>
            {canvasWidth > 900 ?
            
        
            <FeedbackContainer>
                <FormContainer>
                    <Form title="Let Us Know How We Did"
                      sub="We pride ourselves on ensuring our customers are always
                    satisfied with our service, and we’re always striving to improve."
                      btntext="Leave Feedback" contact={sendContact} color="var(--color-orange-500)" shadow="var(--orange-button-shadow)"
                      cardColor="none" cardShadow="none"/>
                </FormContainer>
                      <FeedbackImageContainer>
                        <img src="/feedback_image.svg"/>
                      </FeedbackImageContainer>
            </FeedbackContainer>
            :
            <ContactContainer>
                <Form title="Let Us Know How We Did"
                    sub="We pride ourselves on ensuring our customers are always
                satisfied with our service, and we’re always striving to improve."
                    btntext="Leave Feedback" contact={sendContact} color="var(--color-orange-500)" shadow="var(--orange-button-shadow)"
                    cardColor="none" cardShadow="none"/>
            </ContactContainer>
            }
        </ContactWrapper>
    }
    </>
    )
}

export default Contact;
